export const dashboardTranslations = {
  ar: {
    title: 'لوحة التحكم',
    sales: 'المبيعات',
    purchases: 'المشتريات',
    inventory: 'المخزون',
    lowStock: 'مخزون منخفض',
  },
  en: {
    title: 'Dashboard',
    sales: 'Sales',
    purchases: 'Purchases',
    inventory: 'Inventory',
    lowStock: 'Low Stock',
  },
  fr: {
    title: 'Tableau de bord',
    sales: 'Ventes',
    purchases: 'Achats',
    inventory: 'Inventaire',
    lowStock: 'Stock faible',
  },
}


